export const config = {
  production: {
    apiKey: "AIzaSyCBulj8EZhgjzaW_RZ7nkraY9JvKcoGlRw",
    authDomain: "big-advice.firebaseapp.com",
    databaseURL: "https://big-advice.firebaseio.com",
    projectId: "big-advice",
    storageBucket: "big-advice.appspot.com",
    messagingSenderId: "150409001497"
  },
  development: {
    apiKey: "AIzaSyD940A-zvTWg29dXG9YV7u7xzrUjMFxf_M",
    authDomain: "bigadvice-development.firebaseapp.com",
    databaseURL: "https://bigadvice-development.firebaseio.com",
    projectId: "bigadvice-development",
    storageBucket: "bigadvice-development.appspot.com",
    messagingSenderId: "939444140358"
  }
};



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/environments/firebase.config.ts